import React from 'react'

function FloorplateSkeleton() {
  return (
    <div className="flex h-full w-full items-center justify-center bg-secondaryColour">
      <div className="skeleton pill mb-40 ml-40"></div>
    </div>
  )
}
export default FloorplateSkeleton
